<template>
  <SlideYUpTransition :duration="animationDuration">
    <div
      class="modal fade"
      @mousedown.self="closeModal"
      :class="[
        {
          'show d-flex flex-column justify-content-center': show,
        },
        { 'd-none': !show },
        { 'modal-mini': type === 'mini' },
      ]"
      v-show="show"
      tabindex="-1"
      role="dialog"
      :aria-hidden="!show"
    >
      <div
        class="w-100 modal-dialog"
        :class="[{ 'modal-notice': type === 'notice' }, modalClasses]"
      >
        <div
          class="modal-content"
          :class="[
            gradient ? `bg-gradient-${gradient}` : '',
            modalContentClasses,
          ]"
        >
          <div
            class="modal-header"
            :class="[headerClasses]"
            v-if="$slots.header"
          >
            <slot name="header"></slot>
            <slot name="close-button">
              <button
                type="button"
                class="close"
                v-if="showClose"
                @click="closeModal"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span v-if="closeIcon" :aria-hidden="!show">×</span>
              </button>
            </slot>
          </div>

          <div class="modal-body" :class="bodyClasses">
            <slot></slot>
          </div>

          <div class="modal-footer" :class="footerClasses" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
        <slot
          class="d-flex row"
          name="sub-modal"
          v-if="$slots['sub-modal']"
        ></slot>
      </div>
    </div>
  </SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions';

export default {
  name: 'modal-double',
  components: {
    SlideYUpTransition,
  },
  props: {
    closeIcon: {
      type: Boolean,
      default: true,
    },
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        let acceptedValues = ['', 'notice', 'mini'];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") ',
    },
    modalClasses: {
      type: [Object, String],
      description: 'Modal dialog css classes',
    },
    modalContentClasses: {
      type: [Object, String],
      description: 'Modal dialog content css classes',
    },
    gradient: {
      type: String,
      description: 'Modal gradient type (danger, primary etc)',
    },
    headerClasses: {
      type: [Object, String],
      description: 'Modal Header css classes',
    },
    bodyClasses: {
      type: [Object, String],
      description: 'Modal Body css classes',
    },
    footerClasses: {
      type: [Object, String],
      description: 'Modal Footer css classes',
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: 'Modal transition duration',
    },
  },
  mounted() {
    const documentClasses = document.body.classList;
    documentClasses.add('modal-open');
  },
  destroyed() {
    const documentClasses = document.body.classList;
    documentClasses.remove('modal-open');
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.modal.show {
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-xxl {
  min-width: 90vw;
  max-height: 80vh;
}

.modal-xxl {
  :deep() .modal-body {
    max-height: 90vh;
    overflow: auto;
    overflow-x: hidden;
  }
}

.modal-xxl {
  :deep() .mayday-table {
    max-height: 60vh;
    overflow: auto;
    overflow-x: hidden;
  }
}
</style>
